import carIcon from "../../assets/iconos/car.png"
import { useTranslation } from "react-i18next";

export const useModulosReportes = () => {
    const { t } = useTranslation();
    const MODULOS_REPORTES = [
        {
            id: 1,
            titulo: t('titulo_consolidado_respuestas_checklist'),
            descripcion: t('titulo_consolidado_respuestas_checklist'),
            icono: carIcon,
            color: 'rgba(0, 128, 0, 0.5)',
            href: 'reportes/consolidado-respuestas/consolidado-respuestas',
        },
    ];
    return MODULOS_REPORTES;
};
